"use strict";
/* eslint-disable guard-for-in */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountIterableFunctions = void 0;
const transform_obj_values_1 = require("../transform-obj-values");
const getDefinition = (iterableFunc, wrapper, force) => {
    return force
        ? function (...args) {
            return wrapper(iterableFunc.call(this, ...args));
        }
        : function (...args) {
            const result = iterableFunc.call(this, ...args);
            return wrapper(result);
        };
};
function getValue(wrapper, force) {
    return ([_p, func]) => getDefinition(func, wrapper, force);
}
function mountIterableFunctions(iterableFuncs, wrapper, force = false) {
    return (0, transform_obj_values_1.transformObjValues)(iterableFuncs, getValue(wrapper, force));
}
exports.mountIterableFunctions = mountIterableFunctions;
